<template>
  <PostIndexesDatatable
      :post-indexes="postIndexes"
      :loading="loading"
      :total="total"
      @update="onUpdate"
  />
</template>

<script>
import PostIndexesDatatable from "@/components/PostIndexesDatatable";
import _ from "underscore";
import {AllowPostIndexSearch} from "@/enums/permission";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import PostIndexService from "@/services/post.index.service";

export default {
  name: "SearchPostIndexView",
  components: {
    PostIndexesDatatable
  },
  data() {
    return {
      postIndexes: [],
      total: 0,
      loading: false
    }
  },
  computed: {
    isAllowPostIndexSearch() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPostIndexSearch
      })
    },
  },
  methods: {
    onUpdate(options, filters) {
      this.reloadPostIndexes(options, filters)
    },
    reloadPostIndexes(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {page, itemsPerPage} = options;
      const {region, area, address} = filters;

      const skip = (page - 1) * itemsPerPage;

      PostIndexService.searchSimilarPostIndexes({
        skip: skip,
        limit: itemsPerPage,
        region: region,
        area: area,
        address: address
      })
          .then(response => {
            this.postIndexes = _.map(response.data.Records, postIndexViewModel => {
              return {
                id: postIndexViewModel.Id,
                region: postIndexViewModel.Region,
                area: postIndexViewModel.Area,
                address: postIndexViewModel.Address,
                postCode: postIndexViewModel.PostCode,
              }
            })

            this.total = response.data.Total;
          }, () => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    created() {
      if (this.isAllowPostIndexSearch) {
        this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Поиск пост отделения")
      } else {
        this.$router.go(-1)
      }
    }
  },
  created() {
    if (this.isAllowPostIndexSearch) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Поиск пост-отделений')
    } else {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>